import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Alert,
  Row,
  Col,
  Button,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap'
import api from '../../../../lib/Api'
import { addNotification } from '../../../../redux/notifications'
import LicenseDetail from './LicenseDetail'
import Admin from './AssignAdmin'
import Confirm from './AssignConfirm'
import ErrorBoundary from 'components/ErrorBoundary'
import Loading from 'components/Loading/Loading'
import SchoolLookUp from 'components/SchoolLookUp'
import { validateEmail } from '../../../../lib/util'

class Assign extends React.Component {
  static propTypes = {
    clearSelectedLicense: PropTypes.func.isRequired,
    defaultAdminEmail: PropTypes.string,
    defaultSchoolValues: PropTypes.shape({
      city: PropTypes.string,
      country: PropTypes.string,
      region: PropTypes.string,
      siteId: PropTypes.string,
      siteName: PropTypes.string,
    }),
    toggle: PropTypes.func,
    license: PropTypes.object.isRequired,
    subscriptionId: PropTypes.string.isRequired,
  }
  static defaultProps = {
    defaultAdminValues: {
      email: '',
    },
  }

  static Steps = {
    School: 1,
    LicenseAdmin: 2,
    Confirm: 3,
  }

  constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
      activeTab: Assign.Steps.School,
      isStepValid: false,
      // step School
      selectedSchool: {
        city: '',
        companyName: '',
        country: '',
        netsuiteCustomerId: null,
        nsCustomerId: '',
        organizationName: '',
        region: '',
      },
      // step LicenseAdmin
      email: '',
      previousCustomerIdValidation: '',
      // step Confirm
      isConfirmed: false,
      // validation
      validation: {
        isConfirmed: false,
      },
    }
  }

  schoolSelected = site => {
    const {
      city,
      companyName,
      country,
      netsuiteCustomerId,
      nsCustomerId,
      organizationName,
      region,
    } = site

    this.setState(
      {
        selectedSchool: {
          city,
          companyName,
          country,
          netsuiteCustomerId,
          nsCustomerId,
          organizationName,
          region,
        },
        previousCustomerId: netsuiteCustomerId,
        previousCustomerIdValidation: '',
      },
      this.validate.currentStep,
    )
  }

  toggle = this.props.toggle

  searchCustomersDebounced = value =>
    new Promise((resolve, reject) =>
      this.searchCustomers({ value, resolve, reject }),
    )

  searchCustomers = _.debounce(async params => {
    const { value, resolve, reject } = params
    try {
      const response = await api.get(`/netsuitecustomers/${value}`)
      resolve(response)
    } catch (err) {
      reject(err)
    }
  }, 300)

  customerIdValidateAsync = value => {
    let errorMessage = this.state.previousCustomerIdValidation
    try {
      // if (value === this.state.previousCustomerId) return errorMessage

      if (!value) {
        this.validate.currentStep()
        return
      }

      const formattedValue = value.toString()
      if (!formattedValue.match(/^[0-9]*$/)) {
        errorMessage = 'Customer Id must contain only numbers'
        this.setState({
          previousCustomerId: value,
          previousCustomerIdValidation: errorMessage,
          isStepValid: false,
        })
        return errorMessage
      }
      // API VALIDATION (promise)
      return this.searchCustomersDebounced(value)
        .then(response => {
          let errorMessage = ''
          const school = response.data
          const isValid = !!school
          if (isValid) {
            const { address } = school
            errorMessage = ''
            const currentSchool = {
              country: address.country,
              region: address.region,
              city: address.city,
              netsuiteCustomerId: school.id,
              companyName: school.companyName,
              nsCustomerId: school.nsCustomerId,
              organizationName: school.companyName,
            }
            this.schoolSelected(currentSchool)
          } else errorMessage = `Cannot find Customer Id ${value}`

          this.setState(
            {
              nsCustomerId: '',
              previousCustomerId: value,
              previousCustomerIdValidation: errorMessage,
            },
            this.validate.currentStep,
          )
          return errorMessage
        })
        .catch(err => {
          return err.message
        })
    } catch (err) {
      this.setState(
        {
          nsCustomerId: '',
          previousCustomerId: value,
          previousCustomerIdValidation: err.message,
        },
        this.validate.currentStep,
      )
      return
    }
  }

  handleNsCustomerIdChange = event => {
    this.setState(
      {
        selectedSchool: {
          city: '',
          companyName: '',
          country: '',
          netsuiteCustomerId: null,
          nsCustomerId: '',
          organizationName: '',
          region: '',
          nsCustomerId: event.target.value,
        },
      },
      async () =>
        await this.customerIdValidateAsync(
          this.state.selectedSchool.nsCustomerId,
        ),
    )
  }

  handleStep = data => this.setState(data, this.validate.currentStep)

  handleSchoolSelection = data =>
    this.setState({ selectedSchool: data }, this.validate.currentStep)

  nav = {
    goBack: e => {
      let { activeTab } = this.state
      activeTab--
      this.setState(
        { activeTab, isStepValid: false },
        this.validate.currentStep,
      )
    },
    goNext: e => {
      let { activeTab } = this.state
      activeTab++
      this.setState(
        { activeTab, isStepValid: false },
        this.validate.currentStep,
      )
    },
    goToStep: step => {
      const { activeTab } = this.state
      if (step < activeTab)
        this.setState(
          { activeTab: step, isStepValid: false },
          this.validate.currentStep,
        )
    },
  }

  handleSubmit = e => {
    e.preventDefault()

    const { isConfirmed } = this.state
    if (!isConfirmed) return

    this.setState({ isLoading: true }, this.assignSchoolAndAdmin)
  }

  assignSchoolAndAdmin = async () => {
    const {
      email,
      isConfirmed,
      selectedSchool = { siteId, city, region, country, siteName },
    } = this.state

    const {
      dispatch,
      license,
      clearSelectedLicense,
      updateSubscription,
      subscriptionId,
    } = this.props

    const licenseAssignmentReq = {
      adminEmail: email,
      city: selectedSchool.city,
      country: selectedSchool.country,
      nsCustomerId: selectedSchool.nsCustomerId || '',
      siteName: selectedSchool.companyName || selectedSchool.organizationName,
      region: selectedSchool.region ? selectedSchool.region : '',
      sku: license.sku,
      subscriptionId: subscriptionId,
      isTosConfirmed: isConfirmed,
    }

    api
      .post(`licenses`, licenseAssignmentReq)
      .then(({ data }) => {
        this.setState({ isLoading: false })
        dispatch(
          addNotification({
            color: 'success',
            text:
              "You've successfully assigned a digital product license to this school",
          }),
        )
        clearSelectedLicense()
        updateSubscription()
        this.toggle && this.toggle()
      })
      .catch(err => {
        this.setState({ isLoading: false })
        let errorText = 'License assignment failed. Please try again later.'

        const { response } = err || {}
        const { status, data } = response || {}
        const { detail } = data || {}

        if (status === 400 && !!detail) {
          errorText = detail
        }

        dispatch(
          addNotification({
            color: 'danger',
            text: errorText,
          }),
        )
        clearSelectedLicense()
        this.toggle && this.toggle();
      })
  }

  validate = {
    currentStep: () => {
      const { activeTab } = this.state
      switch (activeTab) {
        case Assign.Steps.School:
          return this.validate.school()

        case Assign.Steps.LicenseAdmin:
          return this.validate.licenseAdmin()

        case Assign.Steps.Confirm:
          return this.validate.confirm()

        default:
          return false
      }
    },
    school: () => {
      const {
        netsuiteCustomerId,
        nsCustomerId,
        organizationName,
      } = this.state.selectedSchool

      const isValid = !(
        (nsCustomerId === null ||
          nsCustomerId === undefined ||
          nsCustomerId === '') &&
        (netsuiteCustomerId === null ||
          netsuiteCustomerId === undefined ||
          netsuiteCustomerId === 0) &&
        (organizationName === '' ||
          organizationName === null ||
          organizationName === undefined)
      )

      this.setState({ isStepValid: isValid })
      return isValid
    },
    licenseAdmin: () => {
      const { email, confirmEmail } = this.state
      const isValid =
        email && confirmEmail && email === confirmEmail && validateEmail(email)
      this.setState({ isStepValid: isValid })
      return isValid
    },
    confirm: () => {
      const { isConfirmed } = this.state
      const isValid = isConfirmed
      this.setState({ isStepValid: isValid })
      return isValid
    },
  }

  render = () => {
    const {
      isLoading,
      activeTab,
      isStepValid,
      email,
      isConfirmed,
      selectedSchool,
      previousCustomerIdValidation,
    } = this.state
    const { license, clearSelectedLicense, defaultAdminEmail } = this.props

    return (
      <ErrorBoundary>
        <Loading isLoading={isLoading} />
        <LicenseDetail license={license} />
        <Nav className="nav-wizard">
          <NavItem className={activeTab > Assign.Steps.School ? 'done' : ''}>
            <NavLink active={activeTab === Assign.Steps.School}>
              <h5 className="mb-0">Step {Assign.Steps.School}</h5>
              Assign School
            </NavLink>
          </NavItem>
          <NavItem
            className={activeTab > Assign.Steps.LicenseAdmin ? 'done' : ''}
          >
            <NavLink active={activeTab === Assign.Steps.LicenseAdmin}>
              <h5 className="mb-0">Step {Assign.Steps.LicenseAdmin}</h5>
              License Administrator
            </NavLink>
          </NavItem>
          <NavItem className={activeTab > Assign.Steps.Confirm ? 'done' : ''}>
            <NavLink active={activeTab === Assign.Steps.Confirm}>
              <h5 className="mb-0">Step {Assign.Steps.Confirm}</h5>
              Confirmation
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane className="lst-step" tabId={Assign.Steps.School}>
            <br />
            <div className="same-height">
              <ErrorBoundary>
                <Alert color="info">
                  Assign license to site by entering the site&#39;s NetSuite
                  Customer ID OR by selecting the site using dropdown menu.
                  <br />
                  If you use the dropdown menu, leave NetSuite Customer ID
                  blank.
                </Alert>
                <Label for="nsCustomerId">
                  Assigned Site&#39;s NetSuite Customer ID
                </Label>
                <Input
                  name="nsCustomerId"
                  onChange={this.handleNsCustomerIdChange}
                  value={selectedSchool.nsCustomerId}
                />
                <Label className="text-danger">
                  {previousCustomerIdValidation}
                </Label>
                <br />
                <SchoolLookUp
                  disabled={!!selectedSchool.nsCustomerId}
                  key={
                    !!selectedSchool.nsCustomerId && selectedSchool.nsCustomerId
                  }
                  onSelection={this.handleSchoolSelection}
                  siteData={!!selectedSchool.nsCustomerId && selectedSchool}
                />
              </ErrorBoundary>
            </div>
          </TabPane>
          <TabPane className="lst-step" tabId={Assign.Steps.LicenseAdmin}>
            <br />
            <Admin
              defaultAdminEmail={defaultAdminEmail}
              onSelect={this.handleStep}
            />
          </TabPane>
          <TabPane className="lst-step" tabId={Assign.Steps.Confirm}>
            <br />
            <Confirm
              email={email}
              onSelect={this.handleStep}
              schoolName={
                selectedSchool.companyName || selectedSchool.organizationName
              }
            />
          </TabPane>
        </TabContent>

        <hr />

        <Row>
          <Col className="text-right">
            <Button
              className="btn-fixed-width"
              color="link"
              onClick={clearSelectedLicense}
            >
              Cancel
            </Button>
            <Button
              className="btn-fixed-width"
              color="primary"
              disabled={activeTab === Assign.Steps.School}
              onClick={this.nav.goBack}
            >
              Previous
            </Button>
            {activeTab < Assign.Steps.Confirm && (
              <Button
                className="btn-fixed-width"
                color="primary"
                disabled={!isStepValid}
                onClick={this.nav.goNext}
              >
                Next
              </Button>
            )}
            {activeTab >= Assign.Steps.Confirm && (
              <Button
                className="btn-fixed-width"
                color="primary"
                disabled={!isConfirmed || !isStepValid}
                onClick={this.handleSubmit}
              >
                Submit
              </Button>
            )}
          </Col>
        </Row>
        <style global jsx>
          {`
            .lst-step {
              min-height: 500px;
            }
          `}
        </style>
      </ErrorBoundary>
    )
  }
}

export default connect()(Assign)



// WEBPACK FOOTER //
// ./src/containers/css-admin/subscriptions/setupLicense/Assign.js